import { render, staticRenderFns } from "./CrawlingData.vue?vue&type=template&id=28615336&scoped=true"
import script from "./CrawlingData.vue?vue&type=script&lang=js"
export * from "./CrawlingData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28615336",
  null
  
)

export default component.exports